<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Terms and consent
        i
        //- i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      p.card-text As a MEMBER OF MMC you are hereby obligated to abide the following duties and responsibilities
      ol
        li Pay the instalment of his/her share capital subscription as it falls due and to participate in the capital build-up and savings mobilization activities of the Cooperative;
        li Patronize the Cooperative’s business(es) and services; 
        li Participate in the Members' Education Program;
        li Attend and participate in the deliberation of all matters taken during General Assembly Meetings; 
        li Observe and obey all lawful orders, decisions, rules and regulations adopted by the Board of Directors and the General Assembly; and 
        li Promote the purposes and goals of the Cooperative, the success of its business, the welfare of its members and the cooperative movement in general.  
      p.card-text I hereby agree to apply for membership with MAMBAJAO MULTIPURPOSE COOPERATIVE, and agree to faithfully obey its rules and regulations as set down in its by laws and amendments thereof, or elsewhere, and the decisions of the general membership meetings as well as those of the board of directors. I will agree to pay the required membership fee of ₱200.00. I have undergone PRE-MEMBERSHIP EDUCATION SEMINAR and I also hereby agree to pledge to subscribe initially for ₱250.00 share/shares (common stock) with a par value of ₱100.00 of the Capital Stock of the MMC
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            ValidationProvider(name="aggrement", :rules="{required: {allowFalse: false}}" v-slot="{errors}" slim)
              .custom-control.custom-checkbox
                input.custom-control-input#aggrement(type="checkbox", v-model="form.readsConsent")
                label.custom-control-label(:class="{'text-danger': errors.length > 0}" for="aggrement") AGREE
            ValidationProvider(name="picture" rules="required" v-slot="{errors}" slim ref="pictureProvider")
              .form-group
                label(for="") Please upload your picture:
                .input-group
                  .custom-file
                    input.custom-file-input#picture(type="file" @change="handlePicture" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps")
                    label.custom-file-label(:class="{'border-danger': errors.length > 0}" for="picture") {{form.picture ?form.picture.name :'Choose file'}}
            ValidationProvider(name="valid ID" rules="required" v-slot="{errors}" slim ref="validIdProvider")
              .form-group
                label(for="") Please upload valid ID:
                .input-group
                  .custom-file
                    input.custom-file-input#valid_id(type="file" @change="handleValidId" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps")
                    label.custom-file-label(:class="{'border-danger': errors.length > 0}" for="valid_id") {{form.validId ?form.validId.name :'Choose file'}}
            ValidationProvider(name="picture with valid ID" rules="required" v-slot="{errors}" slim ref="picWithIdProvider")
              .form-group
                label(for="") Please upload picture holding your valid ID:
                .input-group
                  .custom-file
                    input.custom-file-input#pic_with_valid_id(type="file" @change="handlePictureWithId" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps")
                    label.custom-file-label(:class="{'border-danger': errors.length > 0}" for="pic_with_valid_id") {{form.picWithId ?form.picWithId.name :'Choose file'}}
            p.card-text I authorize Mambajao Multipurpose Cooperative representative to conduct inquiries, ocular inspection, and inspect property/ies deem necessary to gather and verify information supplied by the undersigned and to determine my Credit worthiness, now and in the future for credit purposes.
            ValidationProvider(name="authorized", :rules="{required: {allowFalse: false}}" v-slot="{errors}" slim)
              .custom-control.custom-checkbox
                input.custom-control-input#authorized(type="checkbox" v-model="form.authorized")
                label.custom-control-label(:class="{'text-danger': errors.length > 0}" for="authorized") AGREE

</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'
  
  export default {
    name: 'step_5',
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    emits: ['prev', 'input'],

    setup(props, {emit}) {
      const validIdProvider = ref(null)
      const pictureProvider = ref(null)
      const picWithIdProvider = ref(null)
      const form = reactive(props.value)
      const Validation = ref(null)
      const prev = () => {
        emit('prev');
      }
      const validate = () => {
        emit('input', form)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      const handleValidId = async (e) => {
        const { valid } = await validIdProvider.value.validate(e)
        if(valid) {
          form.validId = e.target.files[0]
        }
      }
      const handlePicture = async (e) => {
        const { valid } = await pictureProvider.value.validate(e)
        if(valid) {
          form.picture = e.target.files[0]
        }
      }
      const handlePictureWithId = async (e) => {
        const { valid } = await picWithIdProvider.value.validate(e)
        if(valid) {
          form.picWithId = e.target.files[0]
        }
      }
      return {
        form,
        Validation, validIdProvider, pictureProvider, picWithIdProvider, prev, validate,
        handleValidId, handlePicture, handlePictureWithId
      }
    }
  }
</script>